/**
 * True when this page runs inside another page's frame, such as the Chrome
 * extension's side panel. AdSense does not allow ads inside browser extensions,
 * so ad slots stay empty when framed; the theme is also posted to the parent so
 * the panel around the page matches it.
 *
 * A cross-origin parent can make `window.top` throw: that is a frame too.
 */
export function isFramed(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
